<template>
  <div class="fw" :class="{ 'fw-full': !navTopShown }">
    <header-nav auto-hide></header-nav>

    <div class="fw-stage">
      <!-- 双模式 iframe 容器 -->
      <iframe
          v-if="mode === 'pro'"
          :key="'pro'"
          class="fw-frame"
          src="/fireworks/runoob-test.html"
          allow="fullscreen"
          allowfullscreen
          frameborder="0"></iframe>
      <iframe
          v-if="mode === 'classic'"
          :key="'classic'"
          class="fw-frame"
          src="/fireworks/fireworks-classic.html"
          frameborder="0"></iframe>

      <!-- 模式切换 -->
      <div class="fw-modes">
        <button
            v-for="m in modes"
            :key="m.id"
            type="button"
            class="fw-mode"
            :class="{ active: mode === m.id }"
            @click="mode = m.id">
          <span class="fw-mode-icon">{{ m.icon }}</span>{{ m.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* =====================================================
 * 心愿烟花（双模式）
 * 模式一「华丽盛宴」：runoob-test.html（本地化资源 + 中文设置面板）
 * 模式二「经典星空」：烟花.html（火箭升空 / 天梯 / 超级礼花）
 * 头部导航自动收缩（auto-hide），隐藏时 iframe 铺满全屏；
 * 底部胶囊按钮自由切换模式
 * ===================================================== */
import HeaderNav from "@/components/HeaderNav.vue";
import bus from '../../utils/bus'

export default {
  name: 'Fireworks',
  components: {HeaderNav},
  data () {
    return {
      mode: 'pro',
      navTopShown: true,
      modes: [
        { id: 'pro', name: '华丽盛宴', icon: '🎇' },
        { id: 'classic', name: '经典星空', icon: '🎆' }
      ]
    }
  },
  mounted () {
    // 跟随自动隐藏导航栏：隐藏时内容区铺满全屏
    bus.$on('nav-hidden-change', this.onNavHiddenChange)
    // iframe 内鼠标靠近顶部时（由子页面转发）唤起导航栏
    window.addEventListener('message', this.onFrameMessage)
  },
  beforeDestroy () {
    bus.$off('nav-hidden-change', this.onNavHiddenChange)
    window.removeEventListener('message', this.onFrameMessage)
  },
  methods: {
    onNavHiddenChange (hidden) {
      this.navTopShown = !hidden
    },
    onFrameMessage (e) {
      if (!e.data) return
      if (e.data.type === 'fw-nav-peek') {
        bus.$emit('nav-reveal')
      } else if (e.data.type === 'fw-nav-leave') {
        bus.$emit('nav-hide')
      }
    }
  }
}
</script>

<style scoped>
.fw {
  //height: 100vh;
  padding-top: 60px;
  overflow: hidden;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  transition: padding-top 0.3s ease;
}
.fw.fw-full {
  padding-top: 0;
}
.fw-stage {
  position: relative;
  width: 100%;
  height: calc(100vh - 60px);
  overflow: hidden;
  background: #000;
  transition: height 0.3s ease;
}
.fw-full .fw-stage {
  height: 100vh;
}
.fw-frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 模式切换 */
.fw-modes {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 9;
  padding: 6px;
  border-radius: 999px;
  background: rgba(10, 5, 25, 0.6);
  border: 1px solid rgba(255, 158, 203, 0.35);
  backdrop-filter: blur(6px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}
.fw-mode {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 999px;
  padding: 1px 10px;
  background: transparent;
  color: #ffd3e8;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.fw-mode:hover { background: rgba(255, 158, 203, 0.18); }
.fw-mode.active {
  background: linear-gradient(135deg, #ff8fc7, #ff6fa5);
  color: #fff;
  box-shadow: 0 4px 12px rgba(255, 111, 165, 0.45);
}
.fw-mode-icon { font-size: 15px; }
</style>
